"use client";

import { cn } from "@oreme/ui";
import { cva, type VariantProps } from "class-variance-authority";
import React, { type HTMLAttributes, type ReactElement } from "react";
import type { ThemeTypeEnum } from "@/types";
import { getThemeColor } from "@/utils";

const themeBadgeVariants = cva("inline-block w-6 h-2 rounded-full", {
  variants: {
    color: {
      default: "",
      green: "bg-green-500",
      cyan: "bg-cyan-500",
      orange: "bg-orange-500",
      violet: "bg-violet-500",
    },
  },
});

type ThemeBadgeVariantsProps = VariantProps<typeof themeBadgeVariants>;
type NativeProps = Omit<
  HTMLAttributes<HTMLSpanElement>,
  keyof ThemeBadgeVariantsProps
>;

interface ThemeBadgeProps extends NativeProps, ThemeBadgeVariantsProps {
  theme: ThemeTypeEnum;
}

function ThemeBadge({
  theme,
  className,
}: Readonly<ThemeBadgeProps>): ReactElement {
  const color = getThemeColor(theme) as ThemeBadgeVariantsProps["color"];
  return <span className={cn(themeBadgeVariants({ color, className }))} />;
}

export { ThemeBadge, type ThemeBadgeProps };
